<template>
  <div>
    <TableSkeleton v-show="loading || localLoading" width="200px" />
    <a-table
      :columns="columnsTable"
      :data-source="entitiesInfo.items"
      :scroll="scrollStyle"
      :loading="loading"
      row-key="id"
      size="middle"
      :pagination="entitiesInfo.pagination"
      @change="handleTableChange"
      v-show="!loading && !localLoading"
    >
      <template #bodyCell="{ column, record, text }">
        <template v-if="column.key === 'name'">
          <div class="name">
            <div
              v-if="record.logo"
              class="name__logo"
              :style="`background-image: url('${record.logo}')`"
            />
            <div v-else class="name__logo name__logo--empty" />
            <span>{{ text }}</span>
          </div>
        </template>

        <template v-if="column.key === 'typeofoperation'">
          <router-link :to="`/operations/campaigns/?entity=${record.id}`">
            {{ campaigns(text) }}
          </router-link>
        </template>

        <!-- <template #status="{ record }">
          <span>
            <a-tag v-if="record.status == 1" color="green"> Activo </a-tag>
            <a-tag v-else color="red"> Inactivo </a-tag>
          </span>
        </template> -->

        <template v-if="column.key === 'country'">{{ text?.name }}</template>

        <template v-if="column.key === 'actions'">
          <span class="cell--actions">
            <a-tooltip>
              <template v-slot:title> Editar </template>
              <a class="link--edit" @click="handleShowModalWithRecord($event, record, 'edit')">
                <EditOutlined
                  :style="{
                    fontSize: '20px',
                  }"
                />
              </a>
            </a-tooltip>
            <a-tooltip>
              <template v-slot:title> Eliminar </template>
              <a class="link--edit" @click="handleShowModalWithRecord($event, record, 'delete')">
                <DeleteOutlined
                  :style="{
                    fontSize: '20px',
                  }"
                />
              </a>
            </a-tooltip>
          </span>
        </template>
      </template>
    </a-table>
    <ModalEditEntities
      :record="record"
      v-if="record && openModalType === 'edit'"
      @update="handleUpdate"
      @onCloseModal="handleCloseModalWithRecord"
    />
    <ModalDeleteEntity
      :record="record"
      v-if="record && openModalType === 'delete'"
      @onCloseModal="handleCloseModalWithRecord"
      @onOpenModal="handleModalConfirmCode"
      :emailToDelete="emailToDelete"
    />
    <ModalDeleteEntityConfirmCode
      :record="record"
      v-if="record && openModalType === 'delete-by-code'"
      :emailToDelete="emailToDelete"
      @update="handleUpdate"
      @onCloseModal="handleCloseModalWithRecord"
      @onBackModal="returnModalDelete"
    />
  </div>
</template>

<script>
import ModalEditEntities from "../modals/entities/ModalEditEntities.vue";
import ModalDeleteEntity from "../modals/entities/ModalDeleteEntity.vue";
import ModalDeleteEntityConfirmCode from "../modals/entities/ModalDeleteEntityConfirmCode.vue";

import { UserStatus } from "@/app/shared/utils/enums";

import { defineComponent } from "vue";
import { DeleteOutlined, EditOutlined } from "@ant-design/icons-vue";
import { entitiesTableColumns } from "@/app/entities/utils/constants";
import TableSkeleton from "@/app/shared/components/skeletons/TableSkeleton.vue";

import { useScrollResize } from "@/app/shared/composables/useScrollResize";

export default defineComponent({
  name: "TablaEntities",
  components: {
    ModalEditEntities,
    DeleteOutlined,
    EditOutlined,
    ModalDeleteEntity,
    ModalDeleteEntityConfirmCode,
    TableSkeleton,
  },
  props: {
    loading: {
      type: Boolean,
      default: false,
    },
  },
  setup() {
    const { scrollStyle } = useScrollResize();

    return { scrollStyle };
  },
  data() {
    return {
      confirm: false,
      columns: entitiesTableColumns,
      CreateOrUpdate: {
        visible: false,
        update: false,
      },
      record: null,
      openModalType: "",
      UserStatus,
      emailToDelete: "",
      localLoading: false,
    };
  },
  computed: {
    entitiesInfo() {
      return this.$store.getters["getEntityInfo"];
    },
    columnsTable() {
      // const column = columnsFixedTableLeft(this.columns);
      // return column;
      return this.columns;
    },
  },
  async created() {
    this.localLoading = true;
    await this.handleFetchEntities(this.pagination);
    await this.$store.dispatch("fetchAllZoneTime");
    this.localLoading = false;
  },
  methods: {
    handleModalConfirmCode(email) {
      this.openModalType = "delete-by-code";
      this.emailToDelete = email;
    },
    statusInactive(record) {
      return record.status === UserStatus.inactive;
    },
    handleCloseModalWithRecord() {
      this.record = null;
      this.openModalType = "";
      this.emailToDelete = null;
    },
    handleShowModalWithRecord(event, record, type) {
      this.record = record;
      this.openModalType = type;
    },
    campaigns(counter) {
      if (counter == 0) return "Sin campañas";
      const label = counter == 1 ? "campaña" : "campañas";
      return `${counter} ${label}`;
    },
    handleTableChange(pagination) {
      this.handleFetchEntities(pagination);
    },
    handleFetchEntities(pagination) {
      this.$store.dispatch("fetchAllEntities", { pagination });
    },

    // handlePortfolioClick(entity) {
    //   this.$store.dispatch("setSelectedEntity", entity.id);
    //   this.$router.push("/operations/campaigns");
    // },
    showModal() {
      this.CreateOrUpdate.visible = true;
      this.CreateOrUpdate.update = true;
    },
    hideModal() {
      this.CreateOrUpdate.visible = false;
    },
    returnModalDelete() {
      this.openModalType = "delete";
    },
    handleUpdate() {
      this.$emit("update");
    },
  },
});
</script>

<style lang="sass" scoped>
:deep(.ant-table-thead > tr > th)
  // padding: 10px !important
.name
  display: flex
  align-items: center
  position: relative

  &__logo
    display: block
    width: 25.63px
    height: 25.24px
    background-size: cover
    background-position: center
    border-radius: 50%
    margin-right: 12px

    &--empty
      background-image: url('../../assets/briefcase-blue.svg')

.cell--actions
  display: flex

.link--edit
  margin-right: 16px

.action
  margin-right: 16px
  padding-bottom: 10px !important
</style>

<style>
.ant-table-body::-webkit-scrollbar-track {
  border-radius: 10px;
  background-color: #ffffff;
}
/* .ant-table-body::-webkit-scrollbar,
.ant-table-fixed-header .ant-table-body-inner::-webkit-scrollbar {
  width: 8px;
  height: 8px;
} */
.ant-table-body::-webkit-scrollbar-thumb {
  border-radius: 10px;
  background-color: #d9d9d9;
}
</style>
